import { computed } from 'vue';

import {
  findPartnerField,
  getPartnerFieldConfig,
  type PartnerFieldConfigEntry,
  type PartnerWithFieldConfig,
} from '@/Utils/partners/partnerFieldConfig';

/** Field visibility, required flags, labels and placeholders of a partner, read from its `fieldConfig`. */
export const usePartnerFieldConfig = (partner: () => PartnerWithFieldConfig, fallback: PartnerFieldConfigEntry[] = []) => {
  const partnerFieldConfig = computed(() => getPartnerFieldConfig(partner(), fallback));

  const isPartnerFieldVisible = (field: string) => findPartnerField(partnerFieldConfig.value, field) !== null;

  const isPartnerFieldRequired = (field: string) => findPartnerField(partnerFieldConfig.value, field)?.required === true;

  const getPartnerFieldLabel = ({
    field,
    defaultValue,
    required = isPartnerFieldRequired(field),
  }: {
    field: string;
    defaultValue: string;
    required?: boolean;
  }) => (findPartnerField(partnerFieldConfig.value, field)?.label ?? defaultValue) + (required ? '*' : '');

  const getPartnerFieldPlaceholder = (field: string) => findPartnerField(partnerFieldConfig.value, field)?.placeholder ?? null;

  return {
    partnerFieldConfig,
    isPartnerFieldVisible,
    isPartnerFieldRequired,
    getPartnerFieldLabel,
    getPartnerFieldPlaceholder,
  };
};
